'use client';

import { FC } from 'react';
import { shallow } from 'zustand/shallow';

import { authStore } from 'src/stores/authStore';
import { cartStore } from 'src/stores/cartStore';
import { modalStore } from 'src/stores/modalStore';

import { UserAvatar } from '../../UserAvatar/UserAvatar';
import { HeaderMenuAction } from './HeaderMenuAction';
import { HeaderMenuActionHamburgerMobile } from './HeaderMenuActionHamburgerMobile';

export const HeaderMenuActionHamburger: FC = () => {
  const { userData, userDataLoading } = authStore(
    ({ userData, userDataLoading }) => ({ userData, userDataLoading }),
    shallow,
  );
  const { cartActive } = cartStore((state) => {
    const cartActive = state.cartExpiry && !state.cartExpired;
    return { cartActive };
  }, shallow);
  const { openModal } = modalStore(
    (state) => ({
      openModal: state.openModal,
    }),
    shallow,
  );

  return (
    <>
      <HeaderMenuActionHamburgerMobile
        onClick={() => openModal('mobileMenu')}
        userAvatarProps={{ userData, notification: !!cartActive, loading: userDataLoading }}
      />
      <div className="relative hidden md:block">
        {userData ? (
          <HeaderMenuAction
            onClick={() => openModal('accountMenu')}
            title="Open my account menu"
            data-testid="header-menu-button"
          >
            <UserAvatar userData={userData} notification={!!cartActive} loading={userDataLoading} />
          </HeaderMenuAction>
        ) : (
          <HeaderMenuAction
            href="/forms/auth/start"
            title="Login or create an account"
            data-testid="header-menu-button"
          >
            <UserAvatar userData={null} />
          </HeaderMenuAction>
        )}
      </div>
    </>
  );
};
